// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 283 ? "fe680085" : chunkId) + "." + {"14":"8cffc56cf15b49bc","283":"01da374d915db0fa"}[chunkId] + ".js";
};